import { req } from "./transport";

export type ReleasePlatform = "web" | "android" | "ios";
export type ReleaseNotes = {
  version: string;
  releaseDate: string;
  platforms: ReleasePlatform[];
  improvements: string[];
  fixes: string[];
};
export type PublishedRelease = ReleaseNotes & { id: string };
export type AdminRelease = {
  id: string;
  draft: ReleaseNotes;
  revision: number;
  published: ReleaseNotes | null;
  publishedRevision: number | null;
  publishedAt: string | null;
  updatedAt: string;
};

/** Draft revisions identify the exact saved snapshot to publish; retrying that
 * revision leaves the same public entry. Client UUIDs also keep create retries
 * on one entry when the response is uncertain. */
export const changelogApi = {
  publishedReleases: () => req<{ releases: PublishedRelease[] }>("/changelog", {}, { rejectUnauthorized: true }),
  adminReleases: () => req<{ entries: AdminRelease[] }>("/admin/changelog", {}, { rejectUnauthorized: true }),
  adminRelease: (id: string) => req<{ entry: AdminRelease }>(`/admin/changelog/${encodeURIComponent(id)}`, {}, { rejectUnauthorized: true }),
  createReleaseDraft: (id: string, draft: ReleaseNotes) => req<{ entry: AdminRelease }>("/admin/changelog/drafts", { method: "POST", body: JSON.stringify({ id, draft }) }, { rejectUnauthorized: true }),
  saveReleaseDraft: (id: string, expectedRevision: number, draft: ReleaseNotes) => req<{ entry: AdminRelease }>(`/admin/changelog/${encodeURIComponent(id)}/draft`, { method: "PUT", body: JSON.stringify({ expectedRevision, draft }) }, { rejectUnauthorized: true }),
  publishRelease: (id: string, expectedRevision: number) => req<{ entry: AdminRelease }>(`/admin/changelog/${encodeURIComponent(id)}/publish`, { method: "POST", body: JSON.stringify({ expectedRevision }) }, { rejectUnauthorized: true }),
};
